import { useEffect, useState } from "react";
import api from "@/lib/api";

const LABEL = { usuarios: "Usuários ativos", pecas: "Peças ativas" };

// Mostra quanto do limite do plano a empresa já usa. Sem limite (ou sem plano), não mostra nada.
export function PlanUsage({ kind, refreshKey }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let active = true;
    api.get("/plan/usage").then((r) => { if (active) setData(r.data); }).catch(() => {});
    return () => { active = false; };
  }, [refreshKey]);

  const item = data?.[kind];
  if (!item || !item.limite) return null;
  const pct = Math.min(100, Math.round((item.usados / item.limite) * 100));
  const full = item.usados >= item.limite;
  const near = !full && pct >= 90;
  const bar = full ? "bg-rose-500" : near ? "bg-amber-400" : "bg-sky-500";
  const text = full ? "text-rose-300" : near ? "text-amber-300" : "text-slate-300";

  return (
    <div className="min-w-[220px] max-w-xs" data-testid={`plan-usage-${kind}`}>
      <div className="flex justify-between text-xs mb-1">
        <span className="text-slate-400">{LABEL[kind]}{data.plano ? ` · plano ${data.plano}` : ""}</span>
        <span className={`font-mono ${text}`}>{item.usados.toLocaleString("pt-BR")} / {item.limite.toLocaleString("pt-BR")}</span>
      </div>
      <div className="h-2 rounded-full bg-slate-800 overflow-hidden" role="progressbar" aria-valuemin={0} aria-valuemax={item.limite} aria-valuenow={item.usados} aria-label={`${LABEL[kind]} no plano`}>
        <div className={`h-full ${bar}`} style={{ width: `${pct}%` }} />
      </div>
      {full && <div className="text-xs text-rose-300 mt-1">Limite do plano atingido. Fale com a gente para ampliar.</div>}
      {near && <div className="text-xs text-amber-300 mt-1">Perto do limite do plano.</div>}
    </div>
  );
}
